import { axiosInstance, handleApiRequest } from 'apis/apiClient';
import { LoginRequest, LoginResponse, CheckLoginStatusResponse, CunexCallbackRequest } from 'types/auth';

const authAPI = {
  login: async (loginRequest: LoginRequest) => {
    return handleApiRequest<LoginResponse>(
      axiosInstance.post('/auth/login', loginRequest),
    );
  },
  cunexCallback: async (request: CunexCallbackRequest) => {
    return handleApiRequest<LoginResponse>(
      axiosInstance.post('/auth/cunex/callback', request),
    );
  },
  checkLoginStatus: async () => {
    return handleApiRequest<CheckLoginStatusResponse>(
      axiosInstance.get('/auth/check_login_status'),
    );
  },
};

export default authAPI;
